/**
 * Presentasjonslag for identifikatorer og tekst.
 * Underliggende data beholder sine ID-er (f.eks. «DEMO-D01»); i grensesnitt, rapporter og eksport
 * vises en nøytral kortform («D01»). Koblingen tilbake til kildeposten er intakt via den fulle ID-en.
 */

const MACHINE_PREFIX = 'DEMO-';

/** «DEMO-D01» → «D01». Ukjente/allerede korte ID-er returneres uendret. */
export function machineLabel(machineId) {
  if (!machineId) return '';
  return machineId.startsWith(MACHINE_PREFIX) ? machineId.slice(MACHINE_PREFIX.length) : machineId;
}

/** «D01» → «DEMO-D01» når det finnes i listen av kjente ID-er; ellers uendret. */
export function resolveMachineId(label, knownIds) {
  if (!label) return label;
  if (knownIds.includes(label)) return label;
  const full = `${MACHINE_PREFIX}${label}`;
  return knownIds.includes(full) ? full : label;
}

/**
 * Fjerner «DEMO-» fra sammensatte identifikatorer i løpende tekst og kildepost-ID-er:
 * «TLM-DEMO-D02-2026-10-02-03» → «TLM-D02-2026-10-02-03», «mi-DEMO-D02-…» → «mi-D02-…», «DEMO-REC-0001» → «REC-0001».
 */
export function presentText(text) {
  if (text === null || text === undefined) return text;
  return String(text).replace(/hr-demo-seed-/g, 'seed-').replace(/DEMO-/g, '');
}

/** Avviks-ID for visning («…:R2:DEMO-D01» → «…:R2:D01»). Rutene bruker fortsatt den fulle ID-en. */
export function presentId(id) {
  return presentText(id);
}
